export default "__VITE_ASSET__9013366f__"